/**
  * @class msysLang
  * @description
  * used for obtaining desired translations
  */

import msysListener from 'msysListener'

export default class msysLang extends msysListener {
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates an instance of the class.
  * @param {string} [id] - ID under which the object will listen for messages
  * @param {string} [cfg] - object initial configuration
  * @param {string} [cfg_schema] - additional schema properties from derived classes
  * @param {string} [dependencies] - additional dependencies from derived classes
  */
  constructor(id, cfg, cfg_schema, dependencies) {
    dependencies = _.union(['msysLogger'], dependencies)
    cfg_schema = _.extend({
      prefixes: {
        description: 'list of prefixes requested from server',
        type: 'array',
      },
    }, cfg_schema)
    super(id, cfg, cfg_schema, dependencies)
  } // constructor

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * @description
   * msysDomainClient informs all listeners that connection to mServer is established
   * @param {object} sender - message sender
   * @param {object} params - message parameters
   * @param {string} [params.app_id] - app_id of the server
   * @param {string} params.url - URL of connected server
   * @param {string} [params.ident] - Identity string of server
   * @param {string} [params.client_ip] - IP of the client as recognized by the server
   */
  mmServerConnected(sender, params) {
    if(this.already_requested) return
    const out = {
      languages: LANG.languages,
      prefixes: this.config.prefixes,
    }
    this.publish(':#TRANSLATIONS', 'mmGetTranslations', out)
    this.already_requested = true
  } // mmServerConnected

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * @description
   * Response with translations for given languages
   * @param {object} sender - message sender
   * @param {object} params - message parameters
   * @param {string} [params.csv] - CSV formatted translations with first column as key and subsequent columns as languages; first row contains language codes
   */
  mmTranslations(sender, params) {
    LANG.loadTranslation(params.csv)
  } // mmTranslations
} // msysLang
